import React from 'react';
import { CheckIcon, XIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ComparisonSection() {
  const {
    t
  } = useLanguage();
  const features = [{
    name: t('comparison.ai'),
    crm: true,
    hubspot: false,
    pipedrive: false
  }, {
    name: t('comparison.followup'),
    crm: true,
    hubspot: true,
    pipedrive: 'partial'
  }, {
    name: t('comparison.gdpr'),
    crm: true,
    hubspot: false,
    pipedrive: false
  }, {
    name: t('comparison.forecast'),
    crm: true,
    hubspot: true,
    pipedrive: 'partial'
  }, {
    name: t('comparison.contacts'),
    crm: true,
    hubspot: false,
    pipedrive: true
  }, {
    name: t('comparison.support'),
    crm: true,
    hubspot: 'partial',
    pipedrive: 'partial'
  }, {
    name: t('comparison.costs'),
    crm: true,
    hubspot: false,
    pipedrive: true
  }];
  const renderIcon = (value: boolean | string) => {
    if (value === true) {
      return <CheckIcon className="w-5 h-5 text-green-400" data-id="element-38" />;
    } else if (value === false) {
      return <XIcon className="w-5 h-5 text-red-400" data-id="element-39" />;
    } else {
      return <MinusIcon className="w-5 h-5 text-yellow-400" data-id="element-40" />;
    }
  };
  return <section className="py-16 lg:py-24 bg-[#0d1225]" data-id="element-41">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16" data-id="element-43">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-44">
            {t('comparison.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-45">
            {t('comparison.subtitle')}
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-2xl border border-white/10 overflow-hidden" data-id="element-46">
          {/* Header */}
          <div className="grid grid-cols-4 gap-4 p-4 lg:p-6 border-b border-white/10 bg-white/5" data-id="element-47">
            <div className="flex items-center text-gray-400 font-medium text-sm lg:text-base" data-id="element-48">
              {t('comparison.feature')}
            </div>
            <div className="flex flex-col items-center justify-center text-center" data-id="element-49">
              <div className="text-gray-400 text-xs mb-1" data-id="element-50">
                {t('comparison.optimization')}
              </div>
              <span className="text-[#ff6b35] font-bold text-sm lg:text-base" data-id="element-51">
                CRM Kraft
              </span>
            </div>
            <div className="flex items-center justify-center text-center" data-id="element-52">
              <span className="text-gray-400 font-medium text-sm lg:text-base" data-id="element-53">
                HubSpot
              </span>
            </div>
            <div className="flex items-center justify-center text-center" data-id="element-54">
              <span className="text-gray-400 font-medium text-sm lg:text-base" data-id="element-55">
                Pipedrive
              </span>
            </div>
          </div>

          {/* Rows */}
          {features.map((feature, index) => <div key={index} className={`grid grid-cols-4 gap-4 p-4 lg:p-6 ${index !== features.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-56">
              <div className="text-white text-sm lg:text-base" data-id="element-57">
                {feature.name}
              </div>
              <div className="flex justify-center" data-id="element-58">
                {renderIcon(feature.crm)}
              </div>
              <div className="flex justify-center" data-id="element-59">
                {renderIcon(feature.hubspot)}
              </div>
              <div className="flex justify-center" data-id="element-60">
                {renderIcon(feature.pipedrive)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}